<template>
  <div class="main-footer-containter">
    © {{ year }} Connex. All rights reserved.
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss">
.main-footer-containter {
  font-size: 7px;
  font-family: Gilroy-Regular, Gilroy;
  font-weight: 400;
  color: #000000;
  margin-right: 120px;
  text-align: right;
  margin-bottom: 26.5px;
  margin-top: 53.5px;
}

@media screen and (max-width: 992px) {
  .main-footer-containter {
    font-size: 12px;
    text-align: center;
    margin: 40px auto;
  }
}
</style>
